<template>
  <div
    class="col-md-8 col-lg-4 col-xl-4 p-4 bg-white rounded-0"
    v-if="show"
    data-cy="negociacao-nao-encontrada-container"
  >
    <erro show data-cy="negociacao-nao-encontrada-erro">
      <div data-cy="negociacao-nao-encontrada-msg-valor">
        Não foi possível identificar o valor a ser pago.
      </div>
      <div data-cy="negociacao-nao-encontrada-msg-contato">
        Por favor, entre em contato com a clínica para mais detalhes.
      </div>
    </erro>

    <div
      class="d-flex justify-content-center"
      data-cy="negociacao-nao-encontrada-btn-container"
    >
      <b-button
        variant="white"
        class="btn-outline-primary rounded-0"
        @click="$emit('voltar')"
        data-cy="negociacao-nao-encontrada-btn-voltar"
      >
        <strong data-cy="negociacao-nao-encontrada-btn-voltar-label">
          <font-awesome-icon
            :icon="['fas', 'times']"
            data-cy="negociacao-nao-encontrada-btn-voltar-icon"
          ></font-awesome-icon>
          Voltar
        </strong>
      </b-button>
    </div>
  </div>
</template>

<script>
import Erro from "@/views/erro.vue";

export default {
  name: "negociacaoNaoEncontradaErro",
  components: { Erro },
  emits: ["voltar"],
  props: {
    show: Boolean
  }
};
</script>

<style scoped></style>
